
import { defineComponent } from "vue";
import { Story } from "@/data/game";
import { getImg } from "@/data/story";

import {
  // IonCard,
  // IonCardContent,
  IonText,
  IonChip,
  IonIcon,
  IonLabel,
  IonImg,
} from "@ionic/vue";
import { addIcons } from "ionicons";
import { person, star, time } from "ionicons/icons";
import { useI18n } from "vue-i18n";
addIcons({ person, star, time });
export default defineComponent({
  components: {
    // IonCard,
    // IonCardContent,
    IonText,
    IonChip,
    IonIcon,
    IonLabel,
    IonImg,
  },
  name: "StoryComponent",
  props: {
    story: {
      type: Object as () => Story,
    },
  },
  setup() {
    const { t, mergeLocaleMessage } = useI18n();
    mergeLocaleMessage("en", {
      story: {
        synopsis: "Synopsis",
      },
    });
    mergeLocaleMessage("de", {
      story: {
        synopsis: "Zusammenfassung",
      },
    });
    return { person, star, time, t , getImg};
  },
});
